import ButtonGroupActions, { Action } from '@/components/ButtonGroupActions'
import DownIcons from '@/icons/DownIcons'
import { paths } from '@/utils/path'
import React from 'react'
import { Link } from 'react-router-dom'
import { Breadcrumbs, Typogaphy } from 'vnetwork-ui'

export interface SubHeadersProps {
    breadcrumbs?: {
        title: string
        path: string
    }[]
    actions?: Action[]
    components?: React.ReactNode[]
    className?: string
}

const SubHeaders: React.FC<SubHeadersProps> = ({
    actions = [],
    breadcrumbs = [],
    components = [],
    className = '',
}) => {
    return (
        <>
            <div
                className={`overflow-x-auto w-full flex items-center flex-wrap justify-between gap-4 pb-2 rounded-[8px] ${className}`}
            >
                <Breadcrumbs
                    childrens={[
                        <Link to={paths.home}>
                            <Typogaphy
                                className="whitespace-nowrap flex-shrink-0"
                                tag="span"
                            >
                                Dashboard
                            </Typogaphy>
                        </Link>,
                        ...(breadcrumbs?.map(({ path, title }) => (
                            <Link key={path} to={path}>
                                <Typogaphy
                                    className="whitespace-nowrap flex-shrink-0 capitalize"
                                    tag="span"
                                >
                                    {title}
                                </Typogaphy>
                            </Link>
                        )) || []),
                    ]}
                    separator={<DownIcons className="icon-small rotate-90" />}
                    items={[]}
                    size="small"
                />
            </div>
            {(actions.length > 0 || components.length > 0) && (
                <ButtonGroupActions actions={actions} components={components} />
            )}
        </>
    )
}

export default SubHeaders
